import React, { useEffect, useState, useRef } from "react";
import { getMatchShowResult } from 'service/base';

const MatchResult = ({ match }) => {
    const [scrollIndex, setScrollIndex] = useState(0);
    const scrollRef = useRef(null);
    const rowHeight = 40; // Adjust based on actual row height
    const visibleRows = 7;

    useEffect(() => {
        const interval = setInterval(() => {
            setScrollIndex(prevIndex => {
                const maxIndex = Math.max(0, match.results.length - 1);
                return (prevIndex + 1) % (maxIndex + 1);
            });
        }, 2000); // Change scroll every 3 seconds

        return () => clearInterval(interval);
    }, [match.results.length]);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollIndex * rowHeight; // Adjust 40 based on row height
        }
    }, [scrollIndex]);

    return (
        <div className="shadow-md rounded-lg overflow-hidden xl:mb-6 mx-2 xl:mx-8 border border-solid border-green-500">
            {/* Header */}
            <div className="bg-green-700 text-white text-center px-4 py-2 text-sm font-bold">
                Kết quả trận đấu của: {match.title}
            </div>
            <div className="flex xl:flex-row flex-col space-x-4 mt-2 lg:px-4 xl:gap-0 gap-4" >
                {/* Team Scores */}
                <div className="flex items-center flex-col justify-around xl:justify-start xl:w-1/4 xl:px-0 px-4 border-gray-200 gap-2">
                    <div className="w-full h-auto flex xl:flex-col flex-row justify-center items-center gap-10 xl:gap-0">
                        <div className="flex items-center xl:w-full xl:justify-between xl:mb-4">
                            {/* Home Team */}
                            <div className="flex items-center">
                                <img
                                    src={match.homeTeam.logo}
                                    alt={match.homeTeam.name}
                                    className="w-10 h-10"
                                />
                                <span className="ml-1 text-xs font-bold whitespace-nowrap">{match.homeTeam.name}</span>
                            </div>
                            <div className="flex ml-2 xl:ml-0 items-center justify-center bg-green-500 text-white rounded-full w-8 h-8 font-bold">
                                {match.homeTeam.score}
                            </div>
                        </div>
                        <div className="flex flex-row-reverse xl:flex-row items-center xl:w-full xl:justify-between">
                            {/* Away Team */}
                            <div className="flex flex-row-reverse xl:flex-row items-center">
                                <img
                                    src={match.awayTeam.logo}
                                    alt={match.awayTeam.name}
                                    className="w-10 h-10"
                                />
                                <span className="ml-1 text-xs font-bold whitespace-nowrap">{match.awayTeam.name}</span>
                            </div>
                            <div className="flex items-center justify-center bg-green-500 text-white rounded-full w-8 h-8 font-bold">
                                {match.awayTeam.score}
                            </div>
                        </div>
                    </div>
                    
                    <div className="w-full h-full flex justify-center items-center xl:flex-col flex-row gap-2">
                        <p className="text-[#333] font-roboto text-sm sm:text-base md:text-lg font-bold leading-normal">
                            Số người dự đoán đúng
                        </p>
                        <p className="text-[#1DC356] text-center font-roboto text-md sm:text-lg md:text-3xl font-bold leading-normal">
                           {match.results.length}
                        </p>
                    </div>
                </div>

                {/* Results Table */}
                <div className="overflow-y-auto xl:w-3/4 mx-auto" ref={scrollRef} style={{ maxHeight: `${rowHeight * visibleRows}px` }}>
                    <table className="table-auto w-full text-left text-sm">
                        <thead className="bg-gray-100 text-gray-700 sticky top-0">
                            <tr>
                                <th className="px-1 xl:px-4 py-2 w-1/12 text-center hidden lg:table-cell">STT</th>
                                <th className="px-1 xl:px-4 py-2 w-2/12 text-center">TK</th>
                                <th className="px-1 xl:px-4 py-2 w-4/12 text-center">Họ và Tên</th>
                                <th className="px-1 xl:px-4 py-2 w-2/12 text-center">VIP</th>
                                <th className="px-1 xl:px-4 py-2 w-2/12 text-center">Điểm Thưởng</th>
                            </tr>
                        </thead>
                        <tbody>
                            {match.results.map((result, index) => (
                                <tr
                                    key={index}
                                    className={`${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}
                                >
                                    <td className="px-1 xl:px-4 py-2  text-center hidden lg:table-cell">{index + 1}</td>
                                    <td className="px-1 xl:px-4 py-2  text-center">{result.account}</td>
                                    <td className="px-1 xl:px-4 py-2  text-center">{result.name}</td>
                                    <td className="px-1 xl:px-4 py-2  text-center">{result.vipLevel}</td>
                                    <td className="px-1 xl:px-4 py-2  text-center">{result.point}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
};

const MatchResultsList = () => {
    const [matches, setMatches] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getMatchShowResult();
                console.log("API response:", response);
                if (response.code === 0 && Array.isArray(response.data)) {
                    setMatches(response.data);
                    setError(null);
                } else {
                    setMatches([]);
                    setError("CÙNG OK9 THAM GIA DỰ ĐOÁN TỶ SỐ VÀ NHẬN THƯỞNG HẤP DẪN MỖI NGÀY!");
                }
            } catch (err) {
                setMatches([]);
                setError("Không thể tải kết quả trận đấu");
                console.error("Fetch error:", err);
            }
        };
        fetchData();
    }, []);

    return (
        <div className="xl:w-7/10 md:w-9/10 sm:w-9/10 w-9/10 mx-auto bg-gray-100 border border-solid border-green-500 pb-10 rounded-xl">
            <h2 className="text-2xl font-bold text-center rounded-t-xl text-white bg-green-700 mb-8">
                KẾT QUẢ TRẬN ĐẤU
            </h2>
            {error && <div className="text-red-500 text-center mb-4">{error}</div>}
            <div className="mx-auto flex flex-col gap-2">
                {matches.map((match, index) => (
                    match?.results?.length > 0 &&
                    <MatchResult key={index} match={match} />
                ))}
            </div>
        </div>
    );
};

export default MatchResultsList;
